import { fork, all  } from 'redux-saga/effects';

import { sagas as BotIntelligence } from 'containers/BotIntelligence';
import { sagas as CreateDashboardLink } from 'containers/CreateDashboardLink';
import { sagas as DashboardLinkAccess } from 'containers/DashboardLinkAccess';
import { sagas as DetectSettings } from 'containers/DetectSettings';
import { sagas as DiscoverHistorics } from 'containers/DiscoverHistorics';
import { sagas as NarrativeFeedsSagas } from 'containers/NarrativeFeeds';
import { sagas as ForgotCredentials } from 'containers/ForgotCredentialsModal';
import { sagas as TwitterImports } from 'containers/TwitterImports';
import { sagas as HistoricalImport } from 'containers/HistoricalImport';
import { sagas as Login } from 'containers/Login';
import { sagas as Notification } from 'containers/Notification';
import { sagas as StoryAndSourceChecker } from 'containers/StoryAndSourceChecker';
import { sagas as SyndicatedStoryModal } from 'containers/SyndicatedStoryModal';
import { sagas as WidgetEmbedModal } from 'containers/WidgetEmbedModal';
import { sagas as Zccs } from 'containers/Zccs';
import { sagas as TierOverride } from 'containers/TierOverride';
import { sagas as ZccInstallations } from 'containers/ZccInstallations';
import { sagas as AdminManagement } from 'containers/AdminManagement';
import { sagas as InternalAdminsTab } from 'containers/InternalAdminsTab';
import { sagas as DefaultLocations } from 'containers/DefaultLocations';
import { sagas as UserForm } from 'containers/UserForm';
import { sagas as ComplexWizard } from 'containers/ExampleWizards/ComplexWizard';
import { sagas as TrendingStoriesOverview } from 'containers/TrendingStoriesOverview';
import { sagas as BulkEdition } from 'containers/BulkEdition';
import { sagas as DataSources } from 'containers/DataSources';
import { sagas as DashboardSummary } from 'containers/DashboardSummary';
import ZignalWidgetsSagas  from 'zignal-widgets/lib/sagas';

function* rootSaga() {
  yield all([
    fork(BotIntelligence),
    fork(CreateDashboardLink),
    fork(DashboardLinkAccess),
    fork(DetectSettings),
    fork(ForgotCredentials),
    fork(NarrativeFeedsSagas),
    fork(TwitterImports),
    fork(HistoricalImport),
    fork(Login),
    fork(Notification),
    fork(StoryAndSourceChecker),
    fork(SyndicatedStoryModal),
    fork(WidgetEmbedModal),
    fork(Zccs),
    fork(TierOverride),
    fork(ZignalWidgetsSagas),
    fork(ZccInstallations),
    fork(AdminManagement),
    fork(InternalAdminsTab),
    fork(DefaultLocations),
    fork(UserForm),
    fork(ComplexWizard),
    fork(BulkEdition),
    fork(DataSources),
    fork(TrendingStoriesOverview),
    fork(DiscoverHistorics),
    fork(DashboardSummary)
  ]);
}

export default rootSaga;
